/* global document */
import React from 'react';
import ReactDOM from 'react-dom';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from 'styled-components';
import App from './App/App';
import * as serviceWorker from './serviceWorker';
import './i18n';
import theme from './themes/theme';

const {
  Fonts: { bold },
} = theme;

const materialConfig = createMuiTheme({
  typography: {
    fontFamily: [
      'Toyota',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [{ ...bold }],
      },
    },
  },
});

ReactDOM.render(
  <ThemeProvider theme={materialConfig}>
    <App />
  </ThemeProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
